import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { EachDetail } from '../UserDetails.styles';
import TertiaryButton from '../../Components/Buttons/TertiaryButton/TertiaryButton.component';
import {
  CompanyDataDiv,
  SectionBox,
} from '../../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHome.styles';
// Admin only
const UserAnswers = ({ c }) => {
  const [showAnswers, setShowAnswers] = useState(false);
  return (
    <>
      {c?.complete && (
        <CompanyDataDiv>
          <SectionBox>
            <h3 className="spaceBetween">
              User Answers for the Quiz
              <Suspense fallback={<p>Loading button...</p>}>
                <TertiaryButton
                  span="Show Answers"
                  functionName={() => setShowAnswers((prev) => !prev)}
                />
              </Suspense>
            </h3>
            {showAnswers && (
              <>
                {c?.userAnswers && (
                  <>
                    {Object.entries(c?.userAnswers).length ? (
                      Object.entries(c?.userAnswers).map(([key, value], i) => (
                        <EachDetail key={key}>
                          <p className="greyBorder">
                            {i + 1}: <span>{value}</span>
                          </p>
                        </EachDetail>
                      ))
                    ) : (
                      <p>No user answers available</p>
                    )}
                  </>
                )}
              </>
            )}
          </SectionBox>
        </CompanyDataDiv>
      )}
    </>
  );
};
UserAnswers.propTypes = {
  c: PropTypes.shape({
    userAnswers: PropTypes.object,
    complete: PropTypes.bool,
  }),
};

export default UserAnswers;
